// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles-module--wrapper--dQXQ8","title":"styles-module--title--323EA","content":"styles-module--content--hgazS"};